var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientsFilterLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4238_1794)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4238_1794)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4238_1794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.40283 12.4479H9.03574M9.03574 12.4479V5.79688C9.52366 5.96471 10.6736 6.2544 11.221 6.49366C11.7849 6.74011 11.9495 7.43519 11.9495 8.09315V12.4479M9.03574 12.4479H11.9495M12.5964 12.4479H11.9495",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    stroke: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.93652 12.0487V4.11782C1.93652 2.74981 1.93652 2.06526 2.36763 1.7257C2.79875 1.38615 3.4337 1.57091 4.70416 1.93935L7.42931 2.73018C8.19558 2.95255 8.57876 3.06374 8.80001 3.36732C9.02186 3.67035 9.02187 4.08294 9.02187 4.9092V12.0487",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66319 5.35938H6.29826M4.66319 7.53945H6.29826M6.84328 12.3756V10.8097C6.84328 10.2956 6.84329 10.039 6.68359 9.87924C6.5239 9.71954 6.26719 9.71954 5.75323 9.71954H5.20821C4.69425 9.71954 4.43755 9.71954 4.27786 9.87924C4.11816 10.039 4.11816 10.2956 4.11816 10.8097V12.3923",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#555555"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4238_1794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4238_1794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4238_1794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 14,
    fill: "white",
    transform: "translate(0.333008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientsFilterLight);
export default __webpack_public_path__ + "static/media/clients-filter-light.3740e4d9003cea9c64365c6d254560f6.svg";
export { ForwardRef as ReactComponent };